// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_logo_btn-primary__3Hw-n","logoHeading":"_logo_logoHeading__25wJS","logoLeading":"_logo_logoLeading__2fJHT"};